/**
 * Shared validation rules for presentation file uploads.
 * Used by both the organizer backup modal (PresentationUploadModal)
 * and the participant self-upload section (TicketPresentationSection).
 *
 * The "frontend check" of the full front-end + backend validation requirement.
 */

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB

export const ACCEPT_ATTR = 'audio/*,video/*,image/*,.ppt,.pptx,application/pdf'

const ALLOWED_MIME_PREFIXES = ['audio/', 'video/', 'image/']
const ALLOWED_EXTENSIONS = ['.ppt', '.pptx', '.pdf']
const ALLOWED_MIME_EXACT = [
  'application/pdf',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
]

/** Returns true if the file's MIME type or extension is in the allowed list. */
export function isAllowedFile(file: File): boolean {
  if (ALLOWED_MIME_PREFIXES.some((p) => file.type.startsWith(p))) return true
  if (ALLOWED_MIME_EXACT.includes(file.type)) return true
  const lower = file.name.toLowerCase()
  if (ALLOWED_EXTENSIONS.some((ext) => lower.endsWith(ext))) return true
  return false
}

/** Human-readable byte size (B / KB / MB). */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
